module.exports = __webpack_public_path__ + "img/img-calendar.4a772ee.png";